import { React, Component, Link, Container, _ } from "utils";
import { FairStore, App, Creators } from "model";
import "./pavilions.less";

class Pavilions extends Component {
  static getStores() {
    return [FairStore];
  }

  static calculateState() {
    return {
      fairTheme: FairStore.getState().data.theme,
      frontFairLogo: FairStore.getState().frontFairLogo,
	  startsAt: FairStore.getState().startsAt,
	  endsAt: FairStore.getState().endsAt,
    };
  }

  useDefaultLogo = () => {
    Creators.resetFrontFairLogoUrl();
  };

  render() {
    let { data: pavilions } = this.props;

    let { fairTheme, frontFairLogo, startsAt, endsAt } = this.state;

    let count = 0;

    let fairImg = (
      <img
        src={frontFairLogo}
        onError={this.useDefaultLogo}
        alt={"fair-logo"}
      />
    );

    if (pavilions) {
      count = pavilions.length;
    }

    if (count === 0) {
      return null;
    } else if (count === 1) {
      return (
        <Box theme={fairTheme} fairImg={fairImg}>
          <Pavilion data={pavilions[0]} />
        </Box>
      );
    } else {
      let view = pavilions.map(function(item, index) {
        if (fairTheme === "sezonac") {
          return <SputPavilion key={item.id} data={item} position={index + 1} />;
        } else {
          return <Pavilion key={item.id} data={item} />;
        }
      });

      return (
        <Box theme={fairTheme} fairImg={fairImg} startsAt={startsAt} endsAt={endsAt}>
          {view}
        </Box>
      );
    }
  }
}

// Croatian month names: nominative → genitive case
const monthGenitive = {
  'siječanj': 'siječnja',
  'veljača': 'veljače',
  'ožujak': 'ožujka',
  'travanj': 'travnja',
  'svibanj': 'svibnja',
  'lipanj': 'lipnja',
  'srpanj': 'srpnja',
  'kolovoz': 'kolovoza',
  'rujan': 'rujna',
  'listopad': 'listopada',
  'studeni': 'studenoga',
  'prosinac': 'prosinca',
};

function toGenitive(month) {
  return monthGenitive[month.toLowerCase()] || month;
}

class Box extends Component {
  render() {
    const fromDate = new Date(this.props.startsAt).getDate().toString().padStart(2, '0');
    const fromMonthRaw = new Date(this.props.startsAt).toLocaleString('hr', { month: 'long' });
    const fromMonth = toGenitive(fromMonthRaw);
    const toDate = new Date(this.props.endsAt).getDate().toString().padStart(2, '0');
    const toMonthRaw = new Date(this.props.endsAt).toLocaleString('hr', { month: 'long' });
    const toMonthString = toGenitive(toMonthRaw);
    const toYear = new Date(this.props.endsAt).getFullYear();

    let spacer =
      this.props.theme === "sezonac" ? (
        <div className="sezonac-header">
          <img
            className="sezonac-logo"
            src="https://storage.dankarijera.com/test/api/icons/sezonac-2026-logo.png"
            alt="Sezonac 2026"
            width="110"
            height="110"
          />
          <h1 className="sezonac-title">Sajam poslova u turizmu i sezoni</h1>
          <div className="activity-time">od {fromDate}. {fromMonth} do {toDate}. {toMonthString} {toYear}.</div>
        </div>
      ) : (
        this.props.fairImg
      );

    const activityTime = this.props.theme !== "sezonac" ? (
      <div className="activity-time">od {fromDate}. {fromMonth} do {toDate}. {toMonthString} {toYear}.</div>
    ) : null;

    return (
      <div className="pavilions-box">
        <div className="spacer">{spacer}</div>
        {activityTime}
        <div className="pavilions">{this.props.children}</div>
      </div>
    );
  }
}

function Pavilion({ data }) {
  return (
    <div className="card">
      <Link to={App.pavilionUrl(data)}>
        <div className="card-body">
          <img src={data.imageUrl} alt={data.name} />
          <div className="title">{data.name}</div>
          <div className="description">{data.description}</div>
          <div className="cta">{_("Show Jobs")}</div>
        </div>
      </Link>
      {data.poweredByLogo && (
        <div className="poweredby">
          {_("Powered by")}
          <a href={data.poweredByLink} target="_blank">
            <img alt={data.poweredByTitle} src={data.poweredByLogoUrl} />
          </a>
        </div>
      )}
    </div>
  );
}

function SputPavilion({ data, position }) {
  const { name } = data;
  const categories = name ? name.split(',').map(s => s.trim()) : [];
  const iconUrl = `https://storage.dankarijera.com/test/api/icons/icon-${position}.svg`;

  return (
    <div className="card sput">
      <div
        className="sput-icon"
        style={{
          maskImage: `url(${iconUrl})`,
          WebkitMaskImage: `url(${iconUrl})`
        }}
      />
      <div className="sput-categories">
        {categories.map((cat, index) => (
          <React.Fragment key={index}>
            <div className="sput-category">{cat}</div>
            {index < categories.length - 1 && <div className="sput-delimiter" />}
          </React.Fragment>
        ))}
      </div>
      <Link to={App.pavilionUrl(data)} className="sput-cta">
        Prikaži poslove
      </Link>
    </div>
  );
}

export default Container.create(Pavilions);



// WEBPACK FOOTER //
// ./src/modules/components/pavilions.js